import { render, staticRenderFns } from "./InfoSectionQuotes.vue?vue&type=template&id=2b5ed8ee&"
import script from "./InfoSectionQuotes.vue?vue&type=script&lang=js&"
export * from "./InfoSectionQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports